import * as mailboxApiClient from './mailbox/index.ts';
import { env } from '../api/constants';

export class MailboxApiClient {
    // base url
    private baseURL = env.notificationApi
    private token: string;
    constructor(private tokenInput: string) {
        this.token = tokenInput;
    }

    private requestInit(): mailboxApiClient.Configuration {
        const config =  new mailboxApiClient.Configuration({
            accessToken: () => this.token,
            basePath: this.baseURL,
            headers: {
                Authorization: "Bearer " + this.token
            }
        });

        mailboxApiClient.DefaultConfig.config = config;

        return config;
    }

    getMailboxAddressConfigApi() {
        return new mailboxApiClient.MailboxAddressConfigApi  (this.requestInit());
    }

    getMailboxSubscriptionApi() {
        return new mailboxApiClient.MailboxApi(this.requestInit());
    }

    getMailboxTemplateApi() {
        return new mailboxApiClient.MailboxTemplateApi(this.requestInit());
    }

}